module.exports = __webpack_public_path__ + "static/media/quiz-aventureiro.b2d7d880.png";